import React from 'react';
import { sentenceCase } from 'src/utils/sentenceCase/sentenceCase';

interface SectionHeader {
  label: string;
}

const SectionHeader = ({ label }: SectionHeader) => {
  return (
    <div className="self-stretch px-4 py-2 inline-flex justify-start items-center gap-2">
      <div className="flex-1 justify-start text-primary text-base font-bold font-['Inter'] leading-normal">
        Saved - {sentenceCase(label)}
      </div>
    </div>
  );
};

export default SectionHeader;
